module.exports = __webpack_public_path__ + "static/media/burrito.de5cdb43.svg";